<template>
  <div id="team-sign-up" >
    <!--<van-button type="primary" @click="createTeamBtn(true)" >创建球队</van-button>-->
    <div class="create-team" @click="createTeamBtn(true)" >
      <van-icon name="plus" size="14px" />
      <span>创建球队</span>
    </div>
    <div class="teamTable" >
      <van-row class="title" >
        <van-col span="10">球队名称</van-col>
        <van-col span="14">当前状态</van-col>
      </van-row>
      <div v-if="team" class="tableMain" >
        <!-- 报名审核通过 -->
        <van-row v-for="(item, index) in teamFilter('passTeams')" :key="index" >
          <van-col span="10" >{{ item.name }}</van-col>
          <van-col span="14" >
            <van-col span="8" class="pass-teams" >审核通过</van-col>
            <van-col span="8" class="btn" >
              <van-button size="mini" type="primary" @click="readDet(item)" >查看</van-button>
            </van-col>
            <van-col span="8" class="btn" >
              <van-button size="mini" type="primary" @click="exportData(item)" :disabled="isShowLoading" >{{0?'下载中...':'秩序册'}}</van-button>
            </van-col>
          </van-col>
        </van-row>
        <!-- 报名审核中 -->
        <van-row v-for="(item, index) in teamFilter('signupTeams')" :key="index" >
          <van-col span="10" >{{ item.name }}</van-col>
          <van-col span="14" >
            <van-col span="8" class="signup-teams" >审核中</van-col>
            <van-col span="8" class="btn" >
              <van-button size="mini" type="primary" @click="editDet(item)" >编辑</van-button>
            </van-col>
            <van-col span="8" class="btn" >
              <van-button size="mini" type="primary" @click="exportData(item)" :disabled="isShowLoading" >{{0?'下载中...':'秩序册'}}</van-button>
            </van-col>
          </van-col>
        </van-row>
        <!-- 报名审核未通过 -->
        <van-row v-for="(item, index) in teamFilter('refuseTeams')" :key="index" >
          <van-col span="10" >{{ item.name }}</van-col>
          <van-col span="14" >
            <van-col span="8" class="signup-teams" >已拒绝</van-col>
            <van-col span="8" class="btn">
              <van-button size="mini" type="primary" @click="editDet(item)">编辑</van-button>
            </van-col>
            <van-col span="8" class="btn" >
              <van-button size="mini" type="primary" @click="exportData(item)" :disabled="isShowLoading" >{{0?'下载中...':'秩序册'}}</van-button>
            </van-col>
            <!--<van-col span="7" >-->
              <!--<van-button size="mini" type="primary">报名</van-button>-->
            <!--</van-col>-->
          </van-col>
        </van-row>
        <!-- 待参赛 -->
        <van-row v-for="(item, index) in teamFilter('freeTeams')" :key="index" >
          <van-col span="10" >{{ item.name }}</van-col>
          <van-col span="14" >
            <van-col span="6" class="free-teams" >待参赛</van-col>
            <van-col span="6" >
              <van-button size="mini" type="primary" @click="editDet(item)" >编辑</van-button>
            </van-col>
            <!--<van-col span="6" >-->
              <!--<van-button size="mini" type="primary" @click="organizationTeamSighUpMatchGroup(item.id)" >报名</van-button>-->
            <!--</van-col>-->
            <van-col span="6" >
              <van-button size="mini" type="warning" @click="updateTeam(item)" >删除</van-button>
            </van-col>
            <van-col span="6" class="btn" >
              <van-button size="mini" type="primary" @click="exportData(item)" :disabled="isShowLoading" >{{0?'下载中...':'秩序册'}}</van-button>
            </van-col>
          </van-col>
        </van-row>
        <div style="padding-top: 10px;" >
          注：球队无需审核即可生成PDF秩序册，用户可以手机查看，若需下载打印请在电脑端浏览器操作
        </div>
      </div>
    </div>
    <!-- 创建球队 createTeam -->
    <van-popup class="team" :overlay="false" v-model="createTeamStatus" @scroll.stop="" >
      <div>
        <van-cell-group title="球队名称" >
          <van-field v-model="teamInfo.name" placeholder="请输入球队名称" />
        </van-cell-group>
        <h2>添加球员</h2>
        <van-search
          v-model="teamInfo.searchText"
          placeholder="请输入球员关键词"
          show-action
          shape="round"
          @change="searchPlayer"
          @search="searchPlayer">
          <div slot="action" @click="searchPlayer">搜索</div>
        </van-search>
        <div class="search" >
          <van-list
            v-model="playerLoading"
            :finished="playerFinished"
            finished-text="没有更多了"
            @load="getPlayerList"> <!-- load方法的时候是否需要调一下getTeam方法 -->
            <van-checkbox-group v-model="teamInfo.playerList" >
              <van-checkbox
                v-for="item in playerList"
                :key="item.id"
                :name="item">
                <div>{{ item.trueName }}</div>
                <div>{{ item.gender }}</div>
                <div>{{ item.mobile }}</div>
              </van-checkbox>
            </van-checkbox-group>
          </van-list>
        </div>
        <h2>添加教练员</h2>
        <van-checkbox-group v-model="teamInfo.coachList" >
          <van-checkbox
            v-for="item in coachList"
            :key="item.id"
            :name="item">
            <div>{{ item.trueName }}</div>
            <div>{{ item.mobile }}</div>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="team-btn" >
        <van-button type="default" @click="createTeamStatus = false" >关闭</van-button>
        <van-button v-if="type === 'create'" type="primary" @click="createTeam(false)" >创建</van-button>
        <van-button v-if="type === 'update'" type="primary" @click="updateTeamDet()" >更新</van-button>
        <van-button v-if="type === 'create'" type="primary" @click="createTeam(true)" >报名</van-button>
        <van-button v-if="type === 'update'" type="primary" @click="organizationTeamSighUpMatchGroup()" >报名</van-button>
      </div>
      <div style="width: 100%; height: 20px;" ></div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { getMyOrganization } from '@/api/info'
import { getPlayerList, getCoachList, createTeam, organizationTeamSighUpMatchGroup, getOrganizationTeamList, updateTeam,
  getTeam, updateTeamCoaches, updateTeamPlayers, getOrganizationGroupTeamList, exportTeamData } from '@/api/match'
import { Button, Popup, Field, Search, List, Checkbox, CheckboxGroup, Toast, Row, Col, Icon, Loading } from 'vant'
Vue.use({ Button, Popup, Field, Search, List, Checkbox, CheckboxGroup, Toast}).use(Row).use(Col).use(Icon).use(Loading)
export default {
  name: 'TeamSignUp',
  data() {
    return {
      type: null,
      createTeamStatus: false,
      team: null,
      teamId: null,
      teamInfo: {
        name: null,
        searchText: null,
        pageNum: 0,
        pageSize: 20,
        playerList: [],
        coachList: []
      },
      coachList: [],
      playerList: [],
      playerLoading: false,
      playerFinished: false,
      membershipId: null,
      routerParams: {},
      isShowLoading: false
    }
  },
  created() {
    this.routerParams = this.$route.query
    this.getMyOrganization()
    this.getPlayerList()
    this.getCoachList()
  },
  methods: {
    getPlayerList() {
      let params = {
        trueName: this.teamInfo.searchText,
        pageSize: this.teamInfo.pageSize,
        pageNum: this.teamInfo.pageNum + 1
      }
      getPlayerList(params).then((resolve) => {
        let data = resolve.data
        if (data) {
          // 处理数据
          if (data.list.length > 0) {
            this.playerList = this.playerList.concat(data.list)
            // 处理分页
            this.teamInfo.pageNum = data.pageNum
          } else {
            this.playerFinished = true
          }
          this.playerLoading = false
        }
      })
    },
    getMyOrganization() {
      getMyOrganization().then((resolve) => {
        let data = resolve.data
        this.membershipId = data.membership.id
        this.getOrganizationTeamList()
      })
    },
    searchPlayer() {
      this.teamInfo.pageNum = 0
      this.playerList = []
      this.getPlayerList()
    },
    getCoachList() {
      getCoachList({ organizationId: this.membershipId }).then((resolve) => {
        let data = resolve.data
        this.coachList = data.list
      })
    },
    createTeam(booleanType) {
      let signUp = booleanType
      let params = {
        organizationId: this.membershipId,
        groupId: this.routerParams.groupId,
        name: this.teamInfo.name,
        coaches: JSON.stringify(this.teamInfo.coachList)
      }
      this.teamInfo.playerList.filter(item => {
        if (item.id) {
          item.playerId = String(item.id)
          item.jerseyNo = item.jerseyNo ? item.jerseyNo : '0'
          delete item.id
        }
      })
      params.players = JSON.stringify(this.teamInfo.playerList)
      createTeam(params).then((resolve) => {
        if (resolve && signUp) {
          this.organizationTeamSighUpMatchGroup(resolve.data.id)
        } else if (resolve) {
          this.getOrganizationTeamList()
          Toast('创建成功')
        }
      })
    },
    organizationTeamSighUpMatchGroup(teamId) {
      let params = {
        teamId: teamId ? teamId : this.teamId,
        groupId: this.routerParams.groupId
      }
      organizationTeamSighUpMatchGroup(params).then((resolve) => {
        if (resolve) {
          this.getOrganizationTeamList()
          Toast('报名成功')
        }
      })
    },
    getOrganizationTeamList() {
      let params = {
        organizationId: this.membershipId,
        groupId: this.routerParams.groupId
      }
      getOrganizationGroupTeamList(params).then((resolve) => {
        this.team = resolve.data.list
      })
    },
    updateTeam(team) {
      let params = {
        teamId: team.id,
        name: team.trueName,
        status: -2
      }
      updateTeam(params).then((resolve) => {
        if (resolve) {
          Toast('删除成功')
          this.getOrganizationTeamList()
        }
      })
    },
    editDet(team) {
      /*
      this.createTeamStatus = true
      this.type = 'update'
      this.teamId = team.id
      this.getTeam(team.id)
      */
      this.$router.push({
        path: '/team-detailed-revise',
        query: {
          type: 'update',
          groupId: this.routerParams.groupId,
          teamId: team.id
        }
      })
    },
    readDet(team) {
      this.$router.push({
        path: '/team-detailed-revise',
        query: {
          type: 'read',
          groupId: this.routerParams.groupId,
          teamId: team.id
        }
      })
    },
    getTeam(teamId) {
      getTeam({ teamId: teamId }).then((resolve) => {
        let data = resolve.data.team
        let coachs = []
        let players = []
        this.teamInfo.name = data.name
        data.coaches.map(item => {
          this.coachList.filter(coach => {
            if (item.id === coach.id) {
              coachs.push(coach)
            }
          })
        })
        this.teamInfo.coachList = coachs
        data.players.map(item => {
          this.playerList.filter(player => {
            if (Number(item.playerId) === Number(player.id) || Number(item.playerId) === Number(player.playerId)) {
              players.push(player)
            }
          })
        })
        this.teamInfo.playerList = players
      })
    },
    createTeamBtn(boolan) {
      this.$router.push({
        path: '/team-detailed-revise',
        query: {
          type: 'create',
          groupId: this.routerParams.groupId
        }
      })
      /*
      this.type = 'create'
      this.createTeamStatus = true
      this.teamInfo.name = null
      this.teamInfo.searchText = null
      this.teamInfo.playerList = []
      this.teamInfo.coachList = []
      */
    },
    updateTeamDet() {
      let params = {
        name: this.teamInfo.name,
        teamId: this.teamId,
        coaches: JSON.stringify(this.teamInfo.coachList)
      }
      this.teamInfo.playerList.filter(item => {
        if (item.id) {
          item.playerId = String(item.id)
          item.jerseyNo = item.jerseyNo ? item.jerseyNo : '0'
          delete item.id
        }
      })
      params.players = JSON.stringify(this.teamInfo.playerList)
      axios.all([updateTeamCoaches(params), updateTeamPlayers(params), updateTeam(params)]).then(response => {
        this.getOrganizationTeamList()
        Toast('更新成功')
      })
    },
    teamFilter(type) {
      if (type === 'freeTeams') {
        return this.team.filter(team => {
          return team.auditStatus === -1
        })
      } else if (type === 'signupTeams') {
        return this.team.filter(team => {
          return team.auditStatus === 0
        })
      } else if (type === 'passTeams') {
        return this.team.filter(team => {
          return team.auditStatus === 2
        })
      } else if (type === 'refuseTeams') {
        return this.team.filter(team => {
          return team.auditStatus === 1
        })
      }
    },
    exportData(team) {
      const params = {
        teamId: team.id,
        groupId: this.routerParams.groupId
      }
      // this.isShowLoading = true
      // Toast('下载中，请耐心等待')
      exportTeamData(params).then((resolve) => {
        const data = resolve.data
        if(data && data.email) {
          Toast(`导出成功，请至邮箱：${data.email}查收`)
          // window.open(process.env.BANMA_API + decodeURIComponent(data.url), '_self')
        }
        // this.isShowLoading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  #team-sign-up {
    max-width: 768px; /*px*/
    padding: 15px;
    width: calc(100% - 30px);
    height: calc(100% - 30px);
    left: 0;
    top: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    .create-team {
      background:rgba(24,84,148,1);
      font-size:14px;
      font-weight:400;
      color:rgba(255,255,255,1);
      display: inline-flex;
      align-items: center;
      padding: 8px 15px;
      border-radius: 15px;
      span {
        padding-left: 5px;
      }
    }
    h2 {
      margin: 0;
      font-weight: 400;
      font-size: 16px;
      color: rgba(69, 90, 100, 1);
      padding: 15px 15px 0;
    }
    .team {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      .van-cell-group__title {
        margin: 0;
        font-weight: 400;
        font-size: 16px;
        color: rgba(69, 90, 100, 1);
        padding: 35px 15px 15px;
      }
      .search {
        min-height: 80px;
        max-height: 300px;
        overflow-y: scroll;
      }
      .van-checkbox-group {
        .van-checkbox {
          padding: 15px 10px;
          border-bottom: 1px solid #ebedf0;
          .van-checkbox__label {
            width: auto;
            div {
              display: inline-block;
              padding: 0 10px;
            }
          }
        }
      }
      .team-btn {
        padding-top: 40px;
        text-align: center;
        button {
          margin: 0 10px;
        }
      }
    }
    .teamTable {
      padding: 10px 0;
      .title {
        height: 55px;
        line-height: 55px;
        font-size:16px;
        font-weight:400;
        color:rgba(25,25,25,1);
      }
      .tableMain {
        .van-row {
          height: 55px;
          line-height: 55px;
          border-bottom: 1px solid #F2F2F2;
          .van-col {
            color: #4A4A4A;
            font-size: 14px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            .pass-teams {
              color: #32A377;
            }
            .signup-teams, .free-teams {
              color: #000000;
            }
            .btn {
              float: right;
            }
            .refuse-teams {
              color: #9B9B9B;
            }
            .van-button {
              border-radius: 15px;
              background-color: white;
              border-color: #E2E2E2;
              color: #4A4A4A;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/team-sign-up.vue